/**
 * Global API Bridge
 * 
 * Provides global functions that bridge to API clients for the excel-sheets-generator package.
 * The package expects these functions to be available globally.
 */

import { bdoClient } from './ApiClients';

/**
 * Initialize global API functions
 * Must be called during app initialization before using sheet generators
 */
export function initializeGlobalApiFunctions() {
  // Attach API functions to window object for global access
  const globalWindow = window as any;

  // KEO API Functions
  globalWindow.getKeoData = async (
    clientId: string,
    clientSecret: string,
    eupId: string,
    pageNumber: number,
    pageSize: number,
    year: number
  ) => {
    return await bdoClient.getKeoData(clientId, clientSecret, eupId, pageNumber, pageSize, year);
  };

  globalWindow.getKeoGeneratedData = async (
    clientId: string,
    clientSecret: string,
    eupId: string,
    keoId: string,
    pageNumber: number,
    pageSize: number
  ) => {
    return await bdoClient.getKeoGeneratedData(clientId, clientSecret, eupId, keoId, pageNumber, pageSize);
  };

  globalWindow.getKeoTreatedData = async (
    clientId: string,
    clientSecret: string,
    eupId: string,
    keoId: string,
    pageNumber: number,
    pageSize: number
  ) => {
    return await bdoClient.getKeoTreatedData(clientId, clientSecret, eupId, keoId, pageNumber, pageSize);
  };

  globalWindow.getKeoForwardedData = async (
    clientId: string,
    clientSecret: string,
    eupId: string,
    keoId: string,
    pageIndex?: number,
    pageSize?: number
  ) => {
    return await bdoClient.getKeoForwardedData(clientId, clientSecret, eupId, keoId, pageIndex, pageSize);
  };

  globalWindow.getKeoPrintingPage = async (
    clientId: string,
    clientSecret: string,
    cardNumber: string,
    eupId: string,
    keoId: string
  ) => {
    return await bdoClient.getKeoPrintingPage(clientId, clientSecret, cardNumber, eupId, keoId);
  };

  // KPO API Functions
  globalWindow.getKpoData = async (
    clientId: string,
    clientSecret: string,
    eupId: string,
    pageNumber: number,
    pageSize: number,
    dateFrom: Date,
    dateTo: Date
  ) => {
    return await bdoClient.getKpoData(clientId, clientSecret, eupId, pageNumber, pageSize, dateFrom, dateTo);
  };

  globalWindow.getKpoPrintingPage = async (
    clientId: string,
    clientSecret: string,
    cardNumber: string,
    eupId: string,
    kpoId: string
  ) => {
    return await bdoClient.getKpoPrintingPage(clientId, clientSecret, cardNumber, eupId, kpoId);
  };

  globalWindow.getAllKpoInYearData = async (
    clientId: string,
    clientSecret: string,
    eupId: string,
    year: number,
    pageNumber: number,
    pageSize: number
  ) => {
    return await bdoClient.getAllKpoInYearData(clientId, clientSecret, eupId, year, pageNumber, pageSize);
  };

  console.log('✅ Global API bridge functions initialized');
}
